export const numberToString = (value: number | undefined) => {
  if (typeof value === 'number') {
    return String(value);
  }
  if (!value) {
    return '';
  }
  return value;
};
